import React from 'react';

import { DeliveryTime } from '~src/delivery-time/delivery-time';

import { DeliveryTime as DeliveryTimeDTO } from '../../api/api';
import { useCategoryState } from '../category/category-state';
import { checkIfAnyDeliveryTimeIsUnique } from '../delivery-time/delivery-time-uniq';

interface LocationDeliveryTimeProps {
  deliveryTime: DeliveryTimeDTO;
}

export const LocationDeliveryTime: React.FC<LocationDeliveryTimeProps> = ({ deliveryTime }) => {
  const category = useCategoryState();

  /*
   * We do not show delivery time per pickup point if:
   * 1. keep_delivery_time_after_address=true - means we do not ask carrier for precise
   * delivery time but use the default on (per category).
   * 2. or if in fact all delivery times are the same.
   */
  const showDeliveryTime =
    !category.delivery_time_properties?.keep_delivery_time_after_address &&
    checkIfAnyDeliveryTimeIsUnique(
      category.options,
      category.delivery_time_properties?.use_timespan
    );

  if (!showDeliveryTime) {
    return null;
  }

  return <DeliveryTime type="pickup" deliveryTime={deliveryTime} />;
};
